<template>
    <header class="header-style">
        <!-- Left Spacer / Hamburger Menu -->
        <div class="flex-grow">
            <!-- Hamburger Icon for lg and smaller screens -->
            <div class="hamburger-icon-container">
                <template v-if="(navigationItems.length > 0) && (navigationItems[0].route != null)">
                    <button @click="isSlideoverOpen = true">
                        <!-- Replace with your hamburger icon -->
                        <span class="nav-item-text">☰</span>
                    </button>
                </template>
            </div>

            <!-- Navigation Items for larger than lg screens -->
            <ul :class="{ 'navigation-items': navigationItems.length > 1 }">
                <li v-for="item in navigationItems" :key="item.text">
                    <a v-if="item.route" :href="item.route" class="nav-item-text">{{ item.text }}</a>
                    <div v-else class="nav-item-text">{{ item.text }}</div>
                </li>
            </ul>
        </div>

        <!-- Logo Image in the Middle -->
        <a href="/" class="link-style">
            <img :src="scheppachLogoBase64" alt="scheppach logo" class="scheppach-logo" />
        </a>

        <!-- Right Spacer and slot -->
        <div class="flex-grow right-spacer">
            <div class="end-section">
                <a v-for="iconItem in iconItems" :href="iconItem.route" class="icon-item-text" :key="iconItem.icon">
                    <SMdiIcon :size=28>{{ iconItem.icon }}</SMdiIcon>
                </a>
            </div>
            <div class="ml-4">
                <slot />
            </div>
        </div>
    </header>
</template>

<script setup>
const props = defineProps({
    navigationItems: {
        type: Array,
        required: false,
        default: () => []
    },
    iconItems: {
        type: Array,
        required: false,
        default: () => []
    }
});

const isSlideoverOpen = ref(false);

// Embed the scheppach logo into this component

const scheppachLogoBase64 = "data:image/webp;base64,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"
</script>

<style scoped>
.flex-grow {
    flex: 1;
}

.link-style {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.end-section {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
}

.navigation-items {
    display: none;
    gap: 2rem;
    justify-content: flex-start;
}

/* Header Element: */
header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--scheppach-primary-300);
    padding: 1rem 6rem;
    width: 100%;
    margin: 0 auto;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.05);
}

@media (max-width: 640px) {
    header {
        padding: 0.75rem 1.25rem;
    }
}

/* Hamburger Icon Container: */
.hamburger-icon-container {
    display: none;
}

@media (max-width: 1024px) {
    .hamburger-icon-container {
        display: block;
    }
}

/* Navigation Items: */
.navigation-items {
    display: none;
}

@media (min-width: 1024px) {
    .navigation-items {
        display: flex;
        gap: 2rem;
        justify-content: flex-start;
    }
}

/* Navigation & Icon Items Text */
.nav-item-text,
.icon-item-text {
    color: var(--scheppach-shades-0);
    font-weight: bold;
}


/* Logo Image: */
.scheppach-logo {
    width: 130px;
    height: 45px;
}

/* Right Spacer and Slot Container: */
.right-spacer {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
}
</style>